/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Industri',
  },
  {
    name: '',
    label: 'Deskripsi (Opsional)',
  },
  {
    label: 'status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const inputs = [
  {
    name: 'name',
    label: 'Nama Industri',
    type: '',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'description',
    label: 'Deskripsi Industri',
    type: '',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'is_active',
    label: 'Status',
    type: 'select',
    validation: {},
    col: 12,
    options: [
      {
        name: 'Aktif',
        value: '1',
      },
      {
        name: 'Non-Aktif',
        value: '0',
      },
    ],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
  },
]

const IndustryPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getIndustryHash,
    {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
    []
  )
  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (window.confirm('Yakin ingin menghapus Industri ?')) {
        setLoading(true)
        await MasterServices.deleteIndustry(id)
        toast.success(`Industri Berhasil Dihapus`)
        refresh()
      }
    } catch (error) {
    }
  }

  const onSubmit = async (e: any) => {
    try {
      setSubmit(true)
      e?.preventDefault()
      await (formValue.id ? MasterServices.updateIndustry : MasterServices.storeIndustry)(formValue)
      toast.success(`Berhasil ${formValue.id ? 'Memperbarui' : 'Membuat'} Industri`)
      toggle()
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>{isEdit ? 'Form' : 'Form'} Industri</Modal.Title>
          </Modal.Header>
          <Form onSubmit={onSubmit}>
            <Modal.Body>
              <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={toggle} disabled={submit}>
                Batalkan
              </Button>
              <Button variant='primary' type='submit' disabled={submit}>
                {submit ? 'Loading' : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button type='button' onClick={toggle} className='form-control'>
                  {'  '}+ Tambah
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>{' '}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={5} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={5} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{item.industries_name}</td>
                          <td>{item.industries_description || '-'}</td>
                          <td>
                            {item.industries_is_active == '0' ? (
                              <Button
                                variant='secondary'
                                className='shadow-none btn-sm btn-sm btn-outline btn-outline-secondary'
                              >
                                Non-Aktif
                              </Button>
                            ) : (
                              <Button
                                className='shadow-none btn btn-sm btn-outline btn-outline-success'
                                variant='outline'
                                disabled
                              >
                                Aktif
                              </Button>
                            )}
                          </td>
                          <td>
                            <Button
                              className='btn-sm'
                              onClick={() => {
                                setFormValue({
                                  id: item.industries_id,
                                  name: item.industries_name,
                                  description: item.industries_description,
                                  is_active: item.industries_is_active,
                                })
                                toggle()
                              }}
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const Industry: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Jenis Industri
      </PageTitle>
      <IndustryPage />
    </>
  )
}

export default Industry
